import { useEffect, useRef } from "react";
export function usePreviousProps(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
